module.exports = __webpack_public_path__ + "img/sin.8d0d52b4.png";